
export const CACHE_TYPE = {
  // user
  CACHE_USER_INFO: 'CACHE_USER_INFO', // 用户详情

  CACHE_PERMISSIONS: 'CACHE_PERMISSIONS' // 权限

}

const _setItem = (key, value) => {
  window.sessionStorage.setItem(key, value)
}

export const _getItem = (key, defaultValue) => {
  let str = window.sessionStorage.getItem(key)
  if (str) {
    return str
  } else {
    return defaultValue
  }
}

export const clearUserInfo = () => {
  window.sessionStorage.clear()
}

const _getItemParse = (key) => {
  let str = window.sessionStorage.getItem(key)
  if (str) {
    return JSON.parse(str)
  } else {
    return ''
  }
}

/**
 * ==================================================================
 * */

// 用户详细信息
export const setUserInfo = (userInfo) => {
  _setItem(CACHE_TYPE.CACHE_USER_INFO, JSON.stringify(userInfo))
}
export const getUserInfo = () => {
  return _getItemParse(CACHE_TYPE.CACHE_USER_INFO)
}

// 权限信息
export const setPermissions = (permissions) => {
  _setItem(CACHE_TYPE.CACHE_PERMISSIONS, JSON.stringify(permissions))
}
export const getPermissions = () => {
  return _getItemParse(CACHE_TYPE.CACHE_PERMISSIONS)
}
